/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_Toggle_MenuInputs */

const en_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle menu`)
};

const es_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir o cerrar menú`)
};

const de_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü öffnen/schließen`)
};

const zh_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开/关闭菜单`)
};

const ar_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح أو إغلاق القائمة`)
};

const fr_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir/fermer le menu`)
};

const vi_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở hoặc đóng menu`)
};

const sw_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua/funga menyu`)
};

const th_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด/ปิดเมนู`)
};

const bs_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otvori ili zatvori meni`)
};

const ja_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニューを開く/閉じる`)
};

const ko_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메뉴 열기/닫기`)
};

const pt_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir/fechar menu`)
};

const it_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri/chiudi menu`)
};

const sv_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öppna/stäng menyn`)
};

const nl_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu openen/sluiten`)
};

const da_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åbn/luk menu`)
};

const nb_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åpne/lukk menyen`)
};

const fi_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaa/sulje valikko`)
};

const pl_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz/zamknij menu`)
};

const ru_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть/закрыть меню`)
};

const tr_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menüyü aç/kapat`)
};

const hi_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेनू खोलें/बंद करें`)
};

const id_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka/tutup menu`)
};

const ms_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka/tutup menu`)
};

const cs_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít/zavřít menu`)
};

const el_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Άνοιγμα/κλείσιμο μενού`)
};

const he_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פתיחה/סגירה של התפריט`)
};

const af_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak kieslys oop/toe`)
};

const hu_nav_aria_toggle_menu = /** @type {(inputs: Nav_Aria_Toggle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü megnyitása/bezárása`)
};

/**
* | output |
* | --- |
* | "Toggle menu" |
*
* @param {Nav_Aria_Toggle_MenuInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_aria_toggle_menu = /** @type {((inputs?: Nav_Aria_Toggle_MenuInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_Toggle_MenuInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_aria_toggle_menu(inputs)
	if (locale === "de") return de_nav_aria_toggle_menu(inputs)
	if (locale === "zh") return zh_nav_aria_toggle_menu(inputs)
	if (locale === "ar") return ar_nav_aria_toggle_menu(inputs)
	if (locale === "fr") return fr_nav_aria_toggle_menu(inputs)
	if (locale === "vi") return vi_nav_aria_toggle_menu(inputs)
	if (locale === "sw") return sw_nav_aria_toggle_menu(inputs)
	if (locale === "th") return th_nav_aria_toggle_menu(inputs)
	if (locale === "bs") return bs_nav_aria_toggle_menu(inputs)
	if (locale === "ja") return ja_nav_aria_toggle_menu(inputs)
	if (locale === "ko") return ko_nav_aria_toggle_menu(inputs)
	if (locale === "pt") return pt_nav_aria_toggle_menu(inputs)
	if (locale === "it") return it_nav_aria_toggle_menu(inputs)
	if (locale === "sv") return sv_nav_aria_toggle_menu(inputs)
	if (locale === "nl") return nl_nav_aria_toggle_menu(inputs)
	if (locale === "da") return da_nav_aria_toggle_menu(inputs)
	if (locale === "nb") return nb_nav_aria_toggle_menu(inputs)
	if (locale === "fi") return fi_nav_aria_toggle_menu(inputs)
	if (locale === "pl") return pl_nav_aria_toggle_menu(inputs)
	if (locale === "ru") return ru_nav_aria_toggle_menu(inputs)
	if (locale === "tr") return tr_nav_aria_toggle_menu(inputs)
	if (locale === "hi") return hi_nav_aria_toggle_menu(inputs)
	if (locale === "id") return id_nav_aria_toggle_menu(inputs)
	if (locale === "ms") return ms_nav_aria_toggle_menu(inputs)
	if (locale === "cs") return cs_nav_aria_toggle_menu(inputs)
	if (locale === "el") return el_nav_aria_toggle_menu(inputs)
	if (locale === "he") return he_nav_aria_toggle_menu(inputs)
	if (locale === "af") return af_nav_aria_toggle_menu(inputs)
	if (locale === "hu") return hu_nav_aria_toggle_menu(inputs)
	return en_nav_aria_toggle_menu(inputs)
});